import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import C from "../../Constants";
import {AddCircle, KeyboardArrowLeft, KeyboardArrowRight, RemoveCircle} from "@material-ui/icons";
import {Button, IconButton, Typography} from "@material-ui/core";
import { GridList, GridListTile} from "@material-ui/core";
import Swipe from 'react-easy-swipe';

const styles = theme => ({
    dateSelected: {
        boxSizing: "border-box",
        //border: "2px solid lightgrey",
        backgroundColor: "#80cbc4 !important"
    },
    editDateButtons: {
        width: "40%",
        margin: theme.spacing.unit,
    },
    dateHeaders: {
        fontWeight: "bold",
    },
    hidden: {
        visibility: "hidden",
    }
});

class DaySelector extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            addDateSelected: false,
            removeDateSelected: false,
        };
    }

    render = () => {
        const {classes} = this.props;
        const that = this;
        const addRemoveDaysButtonVisibilityClass = this.isGroupAdmin() ? null : classes.hidden;
        return  <Swipe onSwipeLeft={this.addToDisplayedMonth(1)} onSwipeRight={this.addToDisplayedMonth(-1)}>
        <div style={{width: "100%"}} ref={f => this.container = f}>
            <div style={{width: "100%"}}>
                <IconButton style={{width: "15%"}} onClick={this.addToDisplayedMonth(-1)}
                            color="secondary"><KeyboardArrowLeft/></IconButton>
                <IconButton style={{width: "15%"}}
                            color={this.state.addDateSelected ? "primary" : "secondary"}
                            className={addRemoveDaysButtonVisibilityClass}
                            onClick={this.toggleAddDaysMode}><AddCircle/></IconButton>
                <Typography style={{width: "40%", display: "inline-block", top: "-5px", position: "relative"}}
                            align="center"
                            variant="title">{this.props.displayedMonth.format("MMMM YYYY")}</Typography>
                <IconButton style={{width: "15%"}}
                            color={this.state.removeDateSelected ? "primary" : "secondary"}
                            className={addRemoveDaysButtonVisibilityClass}
                            onClick={this.toggleRemoveDaysMode}><RemoveCircle/></IconButton>
                <IconButton style={{width: "15%"}} onClick={this.addToDisplayedMonth(1)}
                            color="secondary"><KeyboardArrowRight/></IconButton>
            </div>
            <GridList cellHeight="auto" cols={7} style={{textAlign: "center"}}>
                {["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"].map(day => (
                    <GridListTile className={classes.dateHeaders} key={day}>{day}</GridListTile>))}
                {this.monthArray().map(date => {
                    let color = null;
                    let textColor = "black"; //css black
                    if (that.props.groupData != null && that.props.groupData.possibleGroupDates != null) {
                        let possibleDate = that.props.groupData.possibleGroupDates.find((itemDate) => date.format(C.inputDatePatternMoment) == itemDate.date);
                        if (possibleDate != null) {
                            color = possibleDate.full ? "#a5d6a7" : "#d7ffd9";
                        }
                    }
                    if (!date.clone().startOf('month').startOf('day').isSame(this.props.displayedMonth)){
                        textColor = "gray"; //css gray
                    }
                    const selectedDateClass = date.isSame(this.props.selectedDate) ? classes.dateSelected : null;
                    return <GridListTile key={date.format("MM.DD")}><Button
                        id={"dateKey" + date.format("YYYY.MM.DD")}
                        className={selectedDateClass}
                        style={{minWidth: "20px", backgroundColor: color, color: textColor}}
                        onClick={this.dateSelected(date)}>{date.format("DD")}</Button></GridListTile>
                })}
            </GridList>
        </div></Swipe>
    };

    addToDisplayedMonth = addingValue => () => this.props.loginPanel.displayMonth(this.props.displayedMonth.clone().add(addingValue, 'month'));
    toggleRemoveDaysMode = () => this.setState({
        removeDateSelected: !this.state.removeDateSelected,
        addDateSelected: false
    });
    toggleAddDaysMode = () => this.setState({
        addDateSelected: !this.state.addDateSelected,
        removeDateSelected: false
    });
    isGroupAdmin = () => this.props.loginData != null && this.props.loginData.isGroupAdmin;
    dateSelected = date => () => {
        if (this.state.addDateSelected) {
            this.props.loginPanel.addDate(date);
        } else if (this.state.removeDateSelected) {
            this.props.loginPanel.removeDate(date);
        } else {
            //this.setState({displayedMonth: date.clone().startOf('month').startOf('day')});
            this.props.loginPanel.dateSelected(date);

        }
    };
    monthArray = () => {
        const fiveWeeksOfDays = [];
        let dayCounter = 0;
        // start with the day of the week before (so that the selected day is align nicely)
        let dayIterator = this.props.displayedMonth.clone().startOf('week').startOf('day');
        for(let weekNumber = 0; weekNumber < 5 ; weekNumber++) {
            for (let dayOfWeek = 0; dayOfWeek < 7; dayOfWeek++) {
                fiveWeeksOfDays[dayCounter++] = dayIterator;
                dayIterator = dayIterator.clone().add(1, 'day').clone();
            }
        }
        return fiveWeeksOfDays;
    };
}

DaySelector.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DaySelector);